// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 24px;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.breadcrumb {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.header-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.currency-dropdown {
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  min-width: 80px;
}

.currency-dropdown:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.header-tabs {
  display: flex;
  gap: 24px;
}

.header-tab {
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}

.header-tab:hover {
  color: #374151;
}

.header-tab.active {
  color: #3b82f6;
}

.header-tab.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #3b82f6;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":[".header {\n  background-color: white;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 16px 24px;\n}\n\n.header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.breadcrumb {\n  font-size: 16px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.header-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.currency-dropdown {\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  min-width: 80px;\n}\n\n.currency-dropdown:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.header-tabs {\n  display: flex;\n  gap: 24px;\n}\n\n.header-tab {\n  padding: 8px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s;\n}\n\n.header-tab:hover {\n  color: #374151;\n}\n\n.header-tab.active {\n  color: #3b82f6;\n}\n\n.header-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #3b82f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
